import {USER_COLOR_KEY} from "../constants";
import {backgroundColors} from "../contexts/BackgroundColorContext";

export const getStoredUserColor = (): string => {
  const color: string | null = window.localStorage.getItem(USER_COLOR_KEY);
  if (color) {
    return color;
  }
  return backgroundColors.blue;
};
